var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-node',{attrs:{"background-color":"primary","padding":"sm"}},[_c('vs-container',[_c('vs-node',{attrs:{"tag":"span","color":"white"}},[_c('vs-icon',{attrs:{"name":"info-circle"}}),_vm._v("\n      "+_vm._s(_vm.$t('noticeText'))+"\n    ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }